import { createCompositeFooterMainSection } from "./elements/main-section/index.js";
import { createCompositeFooterUtilitySection } from "./elements/utility-section/index.js";
import { createCompositeFooterBase } from "./base.js";
const CreateFooterSimpleElement = (props) => {
  const main = createCompositeFooterMainSection(props);
  const utility = createCompositeFooterUtilitySection(props);
  return createCompositeFooterBase(props, [main, utility]);
};
const createCompositeFooterSimple = CreateFooterSimpleElement;
export {
  createCompositeFooterSimple
};
//# sourceMappingURL=simple.js.map
